import { UserTypeEnum } from "./enums";

export const LOADING_STATES = {
  IDLE: "idle",
  PENDING: "pending",
  FAILED: "failed",
  SUCCEEDED: "succeeded",
} as const;

export const mainColors = {
  minChartColor: 85,
  maxChartColor: 215,
};

export const progressStepStatusMapper = {
  fullFilled: "fullfilled",
  completed: "completed",
  inProgress: "in-progress",
  pending: "pending",
};

type UserTypeMapperType = {
  [key in UserTypeEnum]: {
    userType: UserTypeEnum;
    title: string;
    label: string;
  };
};
type UserTypeMapperNoneType = {
  none: {
    userType: "";
    title: "";
    label: "";
  };
};

export const userTypeMapper = {
  [UserTypeEnum.ListingAgent]: {
    userType: UserTypeEnum.ListingAgent,
    title: "Agent",
    label: "Agent",
  },
  [UserTypeEnum.SellingAgent]: {
    userType: UserTypeEnum.SellingAgent,
    title: "Agent",
    label: "Agent",
  },
  [UserTypeEnum.ListingAssistant]: {
    userType: UserTypeEnum.ListingAssistant,
    title: "Agent",
    label: "Transaction Assistant",
  },
  [UserTypeEnum.SellingAssistant]: {
    userType: UserTypeEnum.SellingAssistant,
    title: "Agent",
    label: "Transaction Assistant",
  },
  [UserTypeEnum.ListingTransactionCoordinator]: {
    userType: UserTypeEnum.ListingTransactionCoordinator,
    title: "Agent",
    label: "Transaction Coordinator",
  },
  [UserTypeEnum.SellingTransactionCoordinator]: {
    userType: UserTypeEnum.SellingTransactionCoordinator,
    title: "Agent",
    label: "Transaction Coordinator",
  },
  [UserTypeEnum.Buyer]: {
    userType: UserTypeEnum.Buyer,
    title: "Buyer/Seller",
    label: "Buyer",
  },
  [UserTypeEnum.Seller]: {
    userType: UserTypeEnum.Seller,
    title: "Buyer/Seller",
    label: "Seller",
  },
  none: { userType: "", title: "", label: "" },
};

export const validationMessages = {
  invalidEmailAddressError: "Invalid email address",
  emailValidationError: "Email field cannot be empty",
  firstNameValidationError: "Fist Name field cannot be empty",
  lastNameValidationError: "Last Name field cannot be empty",
  phoneValidationError: "Phone number isn't valid",
  phoneValidationEmptyError: "Phone field cannot be empty",
  addressValidationError: "Address field cannot be empty",
  // eslint-disable-next-line max-len
  currentPasswordValidationError: "Wrong password",
  passwordValidationError:
    "The password must contain at least 8 characters, including numbers, symbols, uppercase and lowercase letters of the Latin alphabet.",
  confirmPasswordValidationError: "Both passwords must match",
};

// eslint-disable-next-line max-len
export const defaultAvatarImageUrl =
  "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8dXNlcnxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&w=1000&q=80";

export const portfolioLogo =
  "https://media.old-communicator.purlin.tech/AgencyImages/PortfolioEscrow/logo.png";

export const NAME_PENDING = "Pending…";

export const TransactionTypeEnum = {
  none: 0,
  residentialSale: "ResidentialSale",
  purchase: "Purchase",
  bulkSale: "BulkSale",
};
